import { ApiaUtil } from '@apia/components';
import shortcutController from '../classes/shortcutController';
import IconsGallery from './test/IconsGallery';

export default function setAppShortcuts() {
  shortcutController.on(['shift&D', ...'dev'.split(''), 'shift&!'], () => {
    window.dd.emit('develop', true);
  });
  shortcutController.on(
    'icons'.split(''),
    () => {
      ApiaUtil.instance.modals.open({
        children: <IconsGallery />,
        size: 'xxxl-fixed',
        noHeader: true,
      });
    },
    'dev',
  );
}
